<template>
    <div class="bg-silver mt-0 mt-md-1">

        <div class="block-filter">
            <div class="col-12">

                <div class="row">
                    <div class="col-12 ">
                        <a class=" d-block d-md-none text-decoration-none" href="#">
                            <h4 class="mb-3 select-mobile bold pb-2" id="select-filter">
                                Filter het overzicht

                                <div class="float-right row-down">&#9660;</div>
                                <div class="float-right row-up "> &#9650;</div>
                            </h4>
                        </a>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4 ">
                        <h5 class="mb-1 d-none d-md-block">
                            Filter het overzicht
                        </h5>
                    </div>

                </div>
            </div>
            <div class="col-12 select-mobile-options">
                <form @submit.prevent="validateForm" ref="form">
                    <div class="row">

                        <div class="col-12 col-sm-6 col-lg-4 mb-4">

                            <date-picker :config="datePickerOptions"
                                         id="startDate"
                                         :name="startDate"
                                         v-model="startDate"
                                         placeholder="Ingangsdatum"
                                         :value="startDate"
                                         autocomplete="off"
                                         class="form-control bg-white date input-field datetimepicker"/>


                        </div>


                        <div class="col-12 col-sm-6 col-lg-4 mb-4">
                            <select2-multiple-control
                                :options="stations"
                                :settings="{placeholder: stationNameCode}"
                                v-model="selectedStations"
                            />
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 mb-4">
                            <select2-multiple-control
                                :options="products"
                                :settings="{placeholder: fuelName}"
                                v-model="selectedProducts"
                            />
                        </div>

                    </div>


                    <div class="form-group  row">
                        <div class="col-12 col-md-8 order-2  order-md-1 ">
                            <button class="btn btn-red m-0" id="search" type="submit">
                                Zoeken
                                <i class="avia-icons-arrow-left"></i>
                            </button>
                        </div>
                        <div class="col-12 col-md-4 text-md-right text-center m-auto  order-1
                order-md-2">
                            <div class=" btn-gray pt-md-0 pt-3  pb-md-0 pb-3 mb-3 mb-md-0">
                                <i class="avia-icons-wrong icon-padding-right"></i>
                                <a @click="removeAllFilters()" id="remove_all_filters" class="text pointer ">
                                    <u>Alle filters verwijderen</u>
                                </a>

                            </div>
                        </div>
                    </div>


                </form>

            </div>
        </div>

    </div>
</template>

<script>
import moment from "moment";
import DatePicker from 'vue-bootstrap-datetimepicker';

export default {
    components: {
        DatePicker
    },
    props: {
        products: Array,
        stations: Array,
    },
    data() {
        return {
            stationNameCode: "Stationsnaam of -code",
            fuelName: 'Brandstofnaam',
            selectedProducts: [],
            selectedStations: [],
            startDate: '',

            datePickerOptions: {
                showClear: true,
                useCurrent: false,
            },

        };
    },

    computed: {
        formattedStartDateTime() {
            return this.formatDate(this.startDate)
        },
    },
    methods: {
        validateForm(e) {

            this.$emit('getDiscountMutations', {'selectedProducts' :this.selectedProducts, 'selectedStations' :this.selectedStations
                ,'startDate' : this.startDate});
        },
        removeAllFilters() {
            this.startDate = '';
            $('#startDate').data("DateTimePicker").clear()

            this.selectedProducts = [];
            this.selectedStations = [];
        },
        formatDate: (date) => (typeof date === 'object' ? date : moment(date)).format('L'),
    }

}
</script>


